var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.createError)?_c('div',[_c('call-error')],1):(_vm.currentCall)?_c('div',[_c('call-dialog')],1):(_vm.callPreview)?_c('div',[_c('call-preview')],1):_c('div',[_c('generic-loading')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }